// helper: CSV escaping
export const csvEscape = (v) => {
  if (v === null || v === undefined) return "";
  let s = typeof v === "object" ? JSON.stringify(v) : String(v);
  // Escape double-quotes by doubling them
  s = s.replace(/"/g, '""');
  // Wrap if contains comma, quote, or newline
  return /[",\n]/.test(s) ? `"${s}"` : s;
};
